export default __webpack_public_path__ + "components/weather-icon/static/nightmodsnow-19b6b5194b8e55f745ae9b618e98d24c.png";